// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1e2d7f98","583":"43a72ae6","845":"0adfe13f"}[chunkId] + ".chunk.js";
};